// import React from "react";
// import { Link, type To } from "react-router-dom";

// /* ===== Base square button ===== */

// type BaseProps = {
//   // shared
//   title?: string;
//   ariaLabel?: string;
//   size?: number;
//   className?: string;
//   disabled?: boolean;
//   children: React.ReactNode;

//   // decide Link vs button
//   to?: To;                                  // if present -> render <Link>
//   onClick?: React.MouseEventHandler<HTMLButtonElement>;

//   // ✅ optional Link-only props you want to support
//   state?: unknown;
//   replace?: boolean;
//   target?: React.HTMLAttributeAnchorTarget;
//   rel?: string;
// };

// const IconSquareButton: React.FC<BaseProps> = ({
//   to,
//   onClick,
//   title,
//   ariaLabel,
//   size = 28,
//   className = "",
//   disabled,
//   children,

//   // link-only props
//   state,
//   replace,
//   target,
//   rel,
// }) => {
//   const style: React.CSSProperties = {
//     ["--sq-size" as any]: `${size}px`,
//   };
//   const cls = `sqbtn ${className}`.trim();

//   if (to && !disabled) {
//     return (
//       <Link
//         to={to}
//         state={state}
//         replace={replace}
//         target={target}
//         rel={rel}
//         className={cls}
//         style={style}
//         title={title}
//         aria-label={ariaLabel || title}
//       >
//         <span className="sqbtn__icon">{children}</span>
//       </Link>
//     );
//   }

//   return (
//     <button
//       type="button"
//       onClick={onClick}
//       className={cls}
//       style={style}
//       title={title}
//       aria-label={ariaLabel || title}
//       disabled={disabled}
//     >
//       <span className="sqbtn__icon">{children}</span>
//     </button>
//   );
// };

// /* ======= Icons (use currentColor) ======= */

// // Eye (view)
// export const EyeIcon: React.FC<{ size?: number; strokeWidth?: number }> = ({ size = 16, strokeWidth = 1.5 }) => (
//   <svg width={size} height={size} viewBox="0 0 14 14" fill="none" aria-hidden="true">
//     <path
//       d="M1.20283 7.20297C1.15422 7.072 1.15422 6.92793 1.20283 6.79697C1.67632 5.64888 2.48005 4.66724 3.51211 3.97649C4.54418 3.28574 5.75811 2.91699 7 2.91699C8.24189 2.91699 9.45582 3.28574 10.4879 3.97649C11.5199 4.66724 12.3237 5.64888 12.7972 6.79697C12.8458 6.92793 12.8458 7.072 12.7972 7.20297C12.3237 8.35105 11.5199 9.33269 10.4879 10.0234C9.45582 10.7142 8.24189 11.0829 7 11.0829C5.75811 11.0829 4.54418 10.7142 3.51211 10.0234C2.48005 9.33269 1.67632 8.35105 1.20283 7.20297Z"
//       stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round"
//     />
//     <path
//       d="M7 8.75C7.9665 8.75 8.75 7.9665 8.75 7C8.75 6.0335 7.9665 5.25 7 5.25C6.0335 5.25 5.25 6.0335 5.25 7C5.25 7.9665 6.0335 8.75 7 8.75Z"
//       stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round"
//     />
//   </svg>
// );

// // Edit (your 14x14 path)
// export const EditIcon: React.FC<{ size?: number; strokeWidth?: number }> = ({ size = 16, strokeWidth = 1.5 }) => (
//   <svg width={size} height={size} viewBox="0 0 14 14" fill="none" aria-hidden="true">
//     <path
//       d="M7 1.75H2.91667C2.60725 1.75 2.3105 1.87292 2.09171 2.09171C1.87292 2.3105 1.75 2.60725 1.75 2.91667V11.0833C1.75 11.3928 1.87292 11.6895 2.09171 11.9083C2.3105 12.1271 2.60725 12.25 2.91667 12.25H11.0833C11.3928 12.25 11.6895 12.1271 11.9083 11.9083C12.1271 11.6895 12.25 11.3928 12.25 11.0833V7"
//       stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round"
//     />
//     <path
//       d="M10.7188 1.53126C10.9508 1.2992 11.2656 1.16882 11.5938 1.16882C11.9219 1.16882 12.2367 1.2992 12.4688 1.53126C12.7008 1.76332 12.8312 2.07807 12.8312 2.40626C12.8312 2.73445 12.7008 3.0492 12.4688 3.28126L7.21117 8.53943C7.07266 8.67782 6.90154 8.77913 6.71359 8.83401L5.03767 9.32401C4.98748 9.33865 4.93427 9.33953 4.88362 9.32655C4.83297 9.31358 4.78674 9.28722 4.74976 9.25025C4.71279 9.21328 4.68644 9.16705 4.67346 9.1164C4.66049 9.06575 4.66136 9.01254 4.676 8.96234L5.166 7.28643C5.22114 7.09862 5.32265 6.92771 5.46117 6.78943L10.7188 1.53126Z"
//       stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round"
//     />
//   </svg>
// );

// // Trash (your path; made currentColor)
// export const TrashIcon: React.FC<{ size?: number; strokeWidth?: number }> = ({ size = 16, strokeWidth = 1.5 }) => (
//   <svg width={size} height={size} viewBox="0 0 14 14" fill="none" aria-hidden="true">
//     <path
//       d="M5.83333 6.41663V9.91663M8.16667 6.41663V9.91663M11.0833 3.49996V11.6666C11.0833 11.976 10.9604 12.2728 10.7416 12.4916C10.5228 12.7104 10.2261 12.8333 9.91667 12.8333H4.08333C3.77391 12.8333 3.47717 12.7104 3.25838 12.4916C3.03958 12.2728 2.91667 11.976 2.91667 11.6666V3.49996M1.75 3.49996H12.25M4.66667 3.49996V2.33329C4.66667 2.02387 4.78958 1.72713 5.00838 1.50833C5.22717 1.28954 5.52391 1.16663 5.83333 1.16663H8.16667C8.47609 1.16663 8.77283 1.28954 8.99162 1.50833C9.21042 1.72713 9.33333 2.02387 9.33333 2.33329V3.49996"
//       stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round"
//     />
//   </svg>
// );

// /* ======= Variant wrappers (no colors passed from parent) ======= */

// // gray hover (view/edit)
// export const ViewIconButton: React.FC<Omit<BaseProps, "children">> = (p) => (
//   <IconSquareButton {...p} className={`sqbtn--neutral ${p.className || ""}`}>
//     <EyeIcon />
//   </IconSquareButton>
// );

// export const EditIconButton: React.FC<Omit<BaseProps, "children">> = (p) => (
//   <IconSquareButton {...p} className={`sqbtn--neutral ${p.className || ""}`}>
//     <EditIcon />
//   </IconSquareButton>
// );

// // red theme (delete)
// export const DeleteIconButton: React.FC<Omit<BaseProps, "children">> = (p) => (
//   <IconSquareButton {...p} className={`sqbtn--danger ${p.className || ""}`}>
//     <TrashIcon />
//   </IconSquareButton>
// );

// export default IconSquareButton;

import React from "react";
import type {
  ElementType,
  ComponentPropsWithoutRef,
  ReactNode,
  CSSProperties,
} from "react";
import { Link } from "react-router-dom";
import { SquarePen, Eye, Trash2, RefreshCcw, Download, Ban } from "lucide-react";

/* ---------------- Polymorphic plumbing ---------------- */
type AsProp<T extends ElementType> = { as?: T };
type PolymorphicProps<T extends ElementType, P> =
  P & AsProp<T> & Omit<ComponentPropsWithoutRef<T>, keyof P | "as">;

/* ---------------- Visual props for the square ---------------- */
type IconSquareOwnProps = {
  /** Size of the square in px (default 28) */
  size?: number;
  /** Hover theme */
  variant?: "neutral" | "danger" | "warning" | "cancel";
  className?: string;
  style?: CSSProperties;
  title?: string;
  ariaLabel?: string;
  /** Put your SVG here (must use stroke='currentColor') */
  children: ReactNode;
  /** Disabled for any rendered element */
  disabled?: boolean;
};

/**
 * Base square icon container.
 * Auto-picks element by props:
 *   - as (if provided)
 *   - Link if `to` is present
 *   - <a> if `href` is present
 *   - <button> otherwise
 */
export function IconSquare<T extends ElementType = "button">(
  props: PolymorphicProps<T, IconSquareOwnProps>
) {
  const {
    as,
    size = 28,
    variant = "neutral",
    className,
    style,
    title,
    ariaLabel,
    children,
    disabled,
    ...rest
  } = props as any;

  const hasTo = rest?.to != null;
  const hasHref = rest?.href != null;
  const Comp: ElementType = as || (hasTo ? Link : hasHref ? "a" : "button");

  const cls = [
    "sqbtn",
    variant === "danger"
      ? "sqbtn--danger"
      : variant === "warning"
        ? "sqbtn--warning"
        : variant === "cancel"
          ? "sqbtn--cancel"
          : "sqbtn--neutral",
    className || "",
    disabled ? "is-disabled" : "",
  ]
    .join(" ")
    .trim();

  const mergedStyle: CSSProperties = { ["--sq-size" as any]: `${size}px`, ...style };

  const commonProps = {
    className: cls,
    style: mergedStyle,
    title,
    "aria-label": ariaLabel || title,
    "aria-disabled": disabled || undefined,
  } as any;

  // Link
  if (Comp === Link) {
    const { to, state, replace, target, rel, onClick, ...restLink } = rest || {};
    const handleClick = (e: React.MouseEvent) => {
      if (disabled) { e.preventDefault(); e.stopPropagation(); return; }
      onClick?.(e as any);
    };
    return (
      <Link
        to={to}
        state={state}
        replace={replace}
        target={target}
        rel={rel}
        onClick={handleClick}
        {...commonProps}
        {...restLink}
      >
        <span className="sqbtn__icon">{children}</span>
      </Link>
    );
  }

  // Anchor
  if (Comp === "a") {
    const { href, target, rel, onClick, ...restA } = rest || {};
    const handleClick = (e: React.MouseEvent) => {
      if (disabled) { e.preventDefault(); e.stopPropagation(); return; }
      onClick?.(e as any);
    };
    return (
      <a
        href={href}
        target={target}
        rel={rel}
        onClick={handleClick}
        {...commonProps}
        {...restA}
      >
        <span className="sqbtn__icon">{children}</span>
      </a>
    );
  }

  // Button (default)
  const { type = "button", onClick, ...restBtn } = rest || {};
  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (disabled) { e.preventDefault(); e.stopPropagation(); return; }
    onClick?.(e);
  };
  return (
    <button
      type={type}
      disabled={disabled}
      onClick={handleClick}
      {...commonProps}
      {...restBtn}
    >
      <span className="sqbtn__icon">{children}</span>
    </button>
  );
}

/* ---------------- Icons (use currentColor) ---------------- */

export const EyeIcon: React.FC<{ size?: number; strokeWidth?: number }> = ({
  size = 16,
  strokeWidth = 2,
}) => (
  <Eye size={size} strokeWidth={strokeWidth} aria-hidden="true" />
);

export const EditIcon: React.FC<{ size?: number; strokeWidth?: number }> = ({
  size = 16,
  strokeWidth = 2,
}) => (
  <SquarePen
    size={size}            // sets both width/height
    strokeWidth={strokeWidth}
    aria-hidden="true"
  />
);

export const UpdateIcon: React.FC<{ size?: number; strokeWidth?: number }> = ({
  size = 16,
  strokeWidth = 2,
}) => (
  <RefreshCcw
    size={size}            // sets both width/height
    strokeWidth={strokeWidth}
    aria-hidden="true"
  />
);

export const TrashIcon: React.FC<{ size?: number; strokeWidth?: number }> = ({
  size = 16,
  strokeWidth = 2,
}) => (
  <Trash2 size={size} strokeWidth={strokeWidth} aria-hidden="true" />
);

export const DownloadIcon: React.FC<{ size?: number; strokeWidth?: number }> = ({
  size = 16,
  strokeWidth = 2,
}) => (
  <Download size={size} strokeWidth={strokeWidth} aria-hidden="true" />
);

// Unlink (broken chain)
export const UnlinkIcon: React.FC<{ size?: number; strokeWidth?: number }> = ({
  size = 16,
  strokeWidth = 1.5,
}) => (
  <svg width={size} height={size} viewBox="0 0 14 14" fill="none" aria-hidden="true">
    <path d="M4.7 8.9l-1.1 1.1a2.2 2.2 0 1 1-3.1-3.1L2 6"
      stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" />
    <path d="M9.3 5.1l1.1-1.1a2.2 2.2 0 1 1 3.1 3.1L12 8"
      stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" />
    <path d="M5 5l4 4" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" />
  </svg>
);

// Cancel (ban / cancelled)
export const CancelIcon: React.FC<{ size?: number; strokeWidth?: number }> = ({
  size = 16,
  strokeWidth = 2,
}) => (
  <Ban size={size} strokeWidth={strokeWidth} aria-hidden="true" />
);

export const RemovalIcon: React.FC<{ size?: number; strokeWidth?: number }> = ({
  size = 16,
  strokeWidth = 1.5,
}) => (
  <svg width={size} height={size} viewBox="0 0 14 14" fill="none" aria-hidden="true">
    {/* pole */}
    <path d="M7 1.5v11" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" />
    {/* top sign (right) */}
    <path d="M3 3.25h6.5l1.75 1.5-1.75 1.5H3z" stroke="currentColor" strokeWidth={strokeWidth} strokeLinejoin="round" />
    {/* bottom sign (left) */}
    <path d="M11 8.75H4.5L2.75 10.25 4.5 11.75H11z" stroke="currentColor" strokeWidth={strokeWidth} strokeLinejoin="round" />
  </svg>
);

/* ---------------- Permissive wrappers ---------------- */
type AnyPolymorphicProps = { as?: ElementType } & Record<string, any>;

export const ViewIconButton: React.FC<AnyPolymorphicProps> = (p) => (
  <IconSquare {...p} variant="neutral"><EyeIcon /></IconSquare>
);

export const EditIconButton: React.FC<AnyPolymorphicProps> = (p) => (
  <IconSquare {...p} variant="neutral"><EditIcon /></IconSquare>
);

export const UpdateIconButton: React.FC<AnyPolymorphicProps> = (p) => (
  <IconSquare {...p} variant="neutral"><UpdateIcon /></IconSquare>
);


export const DeleteIconButton: React.FC<AnyPolymorphicProps> = (p) => (
  <IconSquare {...p} variant="danger"><TrashIcon /></IconSquare>
);

export const DownloadIconButton: React.FC<AnyPolymorphicProps> = (p) => (
  <IconSquare {...p} variant="neutral"><DownloadIcon /></IconSquare>
);

export const UnlinkIconButton: React.FC<AnyPolymorphicProps> = (p) => (
  <IconSquare {...p} variant="warning"><UnlinkIcon /></IconSquare>
);

export const CancelIconButton: React.FC<AnyPolymorphicProps> = (p) => (
  <IconSquare {...p} variant="cancel"><CancelIcon /></IconSquare>
);
export const RemovalIconButton: React.FC<{ as?: any } & Record<string, any>> = (p) => {
  const { variant, ...rest } = p as any;
  return (
    <IconSquare {...rest} variant={variant ?? "danger"}>
      <RemovalIcon />
    </IconSquare>
  );
};

export default IconSquare;



// import React from "react";
// import type {
//   ElementType, ComponentPropsWithoutRef, ReactNode, CSSProperties
// } from "react";
// import { Link } from "react-router-dom";

// /* ---------- Polymorphic plumbing ---------- */
// type AsProp<T extends ElementType> = { as?: T };
// type PolymorphicProps<T extends ElementType, P> =
//   P & AsProp<T> & Omit<ComponentPropsWithoutRef<T>, keyof P | "as">;

// /* ---------- Visual props for the square ---------- */
// type IconSquareOwnProps = {
//   size?: number;
//   variant?: "neutral" | "danger";
//   className?: string;
//   style?: CSSProperties;
//   title?: string;
//   ariaLabel?: string;
//   children: ReactNode;
//   /** allow disabled across tags */
//   disabled?: boolean;
// };

// export function IconSquare<T extends ElementType = "button">(
//   props: PolymorphicProps<T, IconSquareOwnProps>
// ) {
//   const {
//     as,
//     size = 28,
//     variant = "neutral",
//     className,
//     style,
//     title,
//     ariaLabel,
//     children,
//     disabled,
//     ...rest
//   } = props as any;

//   // Detect routing/anchor props
//   const hasTo = rest?.to != null;
//   const hasHref = rest?.href != null;

//   // Pick element: as > Link(to) > a(href) > button
//   const Comp: ElementType =
//     as || (hasTo ? Link : hasHref ? "a" : "button");

//   const cls = [
//     "sqbtn",
//     variant === "danger" ? "sqbtn--danger" : "sqbtn--neutral",
//     className || "",
//     disabled ? "is-disabled" : "",
//   ].join(" ").trim();

//   const mergedStyle: CSSProperties = {
//     ["--sq-size" as any]: `${size}px`,
//     ...style,
//   };

//   // Build safe prop sets per element type
//   const commonProps = {
//     className: cls,
//     style: mergedStyle,
//     title,
//     "aria-label": ariaLabel || title,
//     "aria-disabled": disabled || undefined,
//   } as any;

//   if (Comp === Link) {
//     const { to, state, replace, target, rel, onClick, ...restLink } = rest || {};
//     const handleClick = (e: React.MouseEvent) => {
//       if (disabled) { e.preventDefault(); e.stopPropagation(); return; }
//       onClick?.(e as any);
//     };
//     return (
//       <Link
//         to={to}
//         state={state}
//         replace={replace}
//         target={target}
//         rel={rel}
//         onClick={handleClick}
//         {...commonProps}
//         {...restLink}
//       >
//         <span className="sqbtn__icon">{children}</span>
//       </Link>
//     );
//   }

//   if (Comp === "a") {
//     const { href, target, rel, onClick, ...restA } = rest || {};
//     const handleClick = (e: React.MouseEvent) => {
//       if (disabled) { e.preventDefault(); e.stopPropagation(); return; }
//       onClick?.(e as any);
//     };
//     return (
//       <a
//         href={href}
//         target={target}
//         rel={rel}
//         onClick={handleClick}
//         {...commonProps}
//         {...restA}
//       >
//         <span className="sqbtn__icon">{children}</span>
//       </a>
//     );
//   }

//   // button (default)
//   const { type = "button", onClick, ...restBtn } = rest || {};
//   const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
//     if (disabled) { e.preventDefault(); e.stopPropagation(); return; }
//     onClick?.(e);
//   };
//   return (
//     <button
//       type={type}
//       disabled={disabled}
//       onClick={handleClick}
//       {...commonProps}
//       {...restBtn}
//     >
//       <span className="sqbtn__icon">{children}</span>
//     </button>
//   );
// }

// /* ---------- Icons (unchanged; use stroke='currentColor') ---------- */
// export const EyeIcon: React.FC<{ size?: number; strokeWidth?: number }> = ({ size = 16, strokeWidth = 1.5 }) => (
//   <svg width={size} height={size} viewBox="0 0 14 14" fill="none" aria-hidden="true">
//     <path d="M1.20283 7.20297C1.15422 7.072 1.15422 6.92793 1.20283 6.79697C1.67632 5.64888 2.48005 4.66724 3.51211 3.97649C4.54418 3.28574 5.75811 2.91699 7 2.91699C8.24189 2.91699 9.45582 3.28574 10.4879 3.97649C11.5199 4.66724 12.3237 5.64888 12.7972 6.79697C12.8458 6.92793 12.8458 7.072 12.7972 7.20297C12.3237 8.35105 11.5199 9.33269 10.4879 10.0234C9.45582 10.7142 8.24189 11.0829 7 11.0829C5.75811 11.0829 4.54418 10.7142 3.51211 10.0234C2.48005 9.33269 1.67632 8.35105 1.20283 7.20297Z"
//       stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round"/>
//     <path d="M7 8.75C7.9665 8.75 8.75 7.9665 8.75 7C8.75 6.0335 7.9665 5.25 7 5.25C6.0335 5.25 5.25 6.0335 5.25 7C5.25 7.9665 6.0335 8.75 7 8.75Z"
//       stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round"/>
//   </svg>
// );

// export const EditIcon: React.FC<{ size?: number; strokeWidth?: number }> = ({ size = 16, strokeWidth = 1.5 }) => (
//   <svg width={size} height={size} viewBox="0 0 14 14" fill="none" aria-hidden="true">
//     <path d="M7 1.75H2.91667C2.60725 1.75 2.3105 1.87292 2.09171 2.09171C1.87292 2.3105 1.75 2.60725 1.75 2.91667V11.0833C1.75 11.3928 1.87292 11.6895 2.09171 11.9083C2.3105 12.1271 2.60725 12.25 2.91667 12.25H11.0833C11.3928 12.25 11.6895 12.1271 11.9083 11.9083C12.1271 11.6895 12.25 11.3928 12.25 11.0833V7"
//       stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round"/>
//     <path d="M10.7188 1.53126C10.9508 1.2992 11.2656 1.16882 11.5938 1.16882C11.9219 1.16882 12.2367 1.2992 12.4688 1.53126C12.7008 1.76332 12.8312 2.07807 12.8312 2.40626C12.8312 2.73445 12.7008 3.0492 12.4688 3.28126L7.21117 8.53943C7.07266 8.67782 6.90154 8.77913 6.71359 8.83401L5.03767 9.32401C4.98748 9.33865 4.93427 9.33953 4.88362 9.32655C4.83297 9.31358 4.78674 9.28722 4.74976 9.25025C4.71279 9.21328 4.68644 9.16705 4.67346 9.1164C4.66049 9.06575 4.66136 9.01254 4.676 8.96234L5.166 7.28643C5.22114 7.09862 5.32265 6.92771 5.46117 6.78943L10.7188 1.53126Z"
//       stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round"/>
//   </svg>
// );

// export const TrashIcon: React.FC<{ size?: number; strokeWidth?: number }> = ({ size = 16, strokeWidth = 1.5 }) => (
//   <svg width={size} height={size} viewBox="0 0 14 14" fill="none" aria-hidden="true">
//     <path d="M5.83333 6.41663V9.91663M8.16667 6.41663V9.91663M11.0833 3.49996V11.6666C11.0833 11.976 10.9604 12.2728 10.7416 12.4916C10.5228 12.7104 10.2261 12.8333 9.91667 12.8333H4.08333C3.77391 12.8333 3.47717 12.7104 3.25838 12.4916C3.03958 12.2728 2.91667 11.976 2.91667 11.6666V3.49996M1.75 3.49996H12.25M4.66667 3.49996V2.33329C4.66667 2.02387 4.78958 1.72713 5.00838 1.50833C5.22717 1.28954 5.52391 1.16663 5.83333 1.16663H8.16667C8.47609 1.16663 8.77283 1.28954 8.99162 1.50833C9.21042 1.72713 9.33333 2.02387 9.33333 2.33329V3.49996"
//       stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round"/>
//   </svg>
// );

// /* ---------- Permissive wrappers (unchanged) ---------- */
// type AnyPolymorphicProps = { as?: ElementType } & Record<string, any>;

// export const ViewIconButton: React.FC<AnyPolymorphicProps> = (p) => (
//   <IconSquare {...p} variant="neutral">
//     <EyeIcon />
//   </IconSquare>
// );
// export const EditIconButton: React.FC<AnyPolymorphicProps> = (p) => (
//   <IconSquare {...p} variant="neutral">
//     <EditIcon />
//   </IconSquare>
// );
// export const DeleteIconButton: React.FC<AnyPolymorphicProps> = (p) => (
//   <IconSquare {...p} variant="danger">
//     <TrashIcon />
//   </IconSquare>
// );
